"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var preferences_list_view_1 = require("./preferences-list.view");
var SellerToolsView = /** @class */ (function (_super) {
    tslib_1.__extends(SellerToolsView, _super);
    function SellerToolsView(props) {
        return _super.call(this, props) || this;
    }
    SellerToolsView.prototype.render = function () {
        var propContents = this.props.content || {}, content = propContents.sellerPreferences || {}, preferences = this.props.sellerPreferences, sectionList = null, sellerToolsPageDesc = content.pageDesc || 'Seller Tools Page'; // TODO: Remove fallback text once content is available
        sectionList = preferences.map(function (element, idx) {
            return (React.createElement("div", { className: "ppvx_tile ppvx_tile--card seller_mainContainer", key: idx, "aria-label": content[element.name].header, "aria-describedby": "card-" + element.name + "Title card-" + element.name + "Desc", tabIndex: 0 },
                React.createElement("div", { className: "col-sm-12 col-md-12 detail-leftCol seller_cardHeader" },
                    React.createElement("span", { id: "card-" + element.name + "Title", className: "seller_sectionTitle" }, content[element.name].header),
                    React.createElement("span", { id: "card-" + element.name + "Desc", className: "detailPanel-subTitle" }, content[element.name].body)),
                React.createElement(preferences_list_view_1.default, { list: element.preferences, content: content[element.name] }),
                React.createElement("div", { className: "seller_prefContainer" },
                    React.createElement("section", { className: "col-sm-12 section" },
                        React.createElement("div", { className: "vx_panel acctPanel detailPanel seller_detailPanel ppvx_divider" })))));
        });
        return (React.createElement("section", { role: "tabpanel", id: "seller_tools", className: "appWrapper_main vx_mainContent active seller_container", "aria-labelledby": "sellerToolsLink", tabIndex: -1 },
            React.createElement("main", { className: "seller_main", "aria-label": sellerToolsPageDesc },
                React.createElement("div", { className: "ppvx_alert ppvx_alert--type_info", role: "alert", tabIndex: 0 },
                    React.createElement("span", { className: "seller_alert test_sellerAlert" }, content.alert)),
                sectionList)));
    };
    return SellerToolsView;
}(React.Component));
var mapStateToProps = function (_a) {
    var content = _a.content, sellerPreferences = _a.sellerPreferences;
    return ({ content: content, sellerPreferences: sellerPreferences });
};
var mapDispatchToProps = function (dispatch) { return ({ dispatch: dispatch }); };
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SellerToolsView);
